import { Card, Flex, Form, Select } from 'antd/lib'
import { GenerateResponseFormType } from 'Types/Tasks.types'
import classes from '../GenerateResponseForm/GenerateResponseForm.module.less'
import styles from './ModelFeedback.module.less'
import TextArea from 'antd/lib/input/TextArea'

type ModelFeedbackFormFieldPropsType = {
    feedbackValues: GenerateResponseFormType['modelFeedbackDetails']
    modelResponseFeedbackCode: { value: number; label: string }[]
}

export const ModelFeedbackFormField = (props: ModelFeedbackFormFieldPropsType) => {
    if (!props.modelResponseFeedbackCode.length) return null
    return (
        <Flex vertical gap={20} className={styles['form-field']}>
            <div className={styles['field-title']}>
                Fill below details for the Feedback on Model response
            </div>
            <Form.List name="modelFeedbackDetails">
                {fields => (
                    <Flex gap={16} vertical>
                        {fields.map((field, index) => {
                            const selectedValue =
                                props.feedbackValues?.[field.name]?.feedbackUsefulness
                            const feedbackLabel = props.modelResponseFeedbackCode?.[index]?.label

                            return (
                                <Card
                                    title={`${index + 1}. ${feedbackLabel}`}
                                    key={field.key}
                                    style={{ border: '1px solid #b2b9bf' }}
                                >
                                    <Form.Item
                                        className={classes.inputField}
                                        style={{ marginBottom: '15px' }}
                                        label={
                                            <div className={classes.inputTitle}>
                                                Feedback Usefulness
                                            </div>
                                        }
                                        rules={[
                                            {
                                                required: true,
                                                message: 'Please select the option',
                                            },
                                        ]}
                                        name={[field.name, 'feedbackUsefulness']}
                                    >
                                        <Select
                                            options={[
                                                {
                                                    key: 'complete',
                                                    label: 'Completely',
                                                    value: 'complete',
                                                },
                                                {
                                                    key: 'partial',
                                                    label: 'Partially',
                                                    value: 'partial',
                                                },
                                                {
                                                    key: 'unused',
                                                    label: "Didn't use",
                                                    value: 'unused',
                                                },
                                            ]}
                                        />
                                    </Form.Item>
                                    {selectedValue && selectedValue !== 'complete' && (
                                        <Form.Item
                                            className={classes.inputField}
                                            label={
                                                <div className={classes.inputTitle}>
                                                    Feedback Usefulness Justification
                                                </div>
                                            }
                                            rules={[
                                                {
                                                    required: true,
                                                    message:
                                                        'Please fill the feedback usefulness justification',
                                                },
                                            ]}
                                            name={[field.name, 'feedbackUsefulnessJustification']}
                                        >
                                            <TextArea rows={6} className={classes.input} />
                                        </Form.Item>
                                    )}
                                    <Form.Item name={[field.name, 'feedbackResultCode']} noStyle>
                                        <input type="hidden" />
                                    </Form.Item>
                                </Card>
                            )
                        })}
                    </Flex>
                )}
            </Form.List>
        </Flex>
    )
}
